
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

// Export as PNG using html2canvas library for automatic download
export async function exportAsPNG(generateExportLayout, waitForImagesToLoad) {
	let exportLayout = null;
	try {
		// Show loading indicator
		const exportBtn = document.getElementById('export-png-btn');
		const originalText = exportBtn.textContent;
		exportBtn.textContent = 'Generating PNG...';
		exportBtn.disabled = true;

        // Create a hidden iframe for export isolation
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.left = '-9999px';
        iframe.style.top = '0';
        iframe.style.width = '1200px';
        iframe.style.height = '800px';
        iframe.style.border = 'none';
        iframe.style.background = 'white';
        document.body.appendChild(iframe);

        // Wait for iframe to load and then populate it
        await new Promise(resolve => {
            iframe.onload = resolve;
            iframe.src = 'about:blank';
        });

        // Get iframe document and write content
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <style>
                    body { margin: 0; padding: 0; background: white; }
                    .export-layout { background: white; padding: 40px; width: 1000px; box-sizing: border-box; margin: 0 auto; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; }
                    .export-header { text-align: center; margin-bottom: 30px; border-bottom: 3px solid #4ecdc4; padding-bottom: 20px; }
                    .export-title { font-size: 2.5rem; color: #333; margin: 0 0 10px 0; font-weight: 700; }
                    .export-progress { font-size: 1.2rem; color: #666; margin: 0; }
                    .export-date { font-size: 0.9rem; color: #999; margin-top: 10px; }
                    .export-category { margin-bottom: 40px; }
                    .export-category-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; }
                    .export-category-title { font-size: 1.8rem; font-weight: 600; margin: 0; }
                    .export-category-progress { font-size: 1rem; color: #666; }
                    .export-food-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 15px; }
                    .export-food-card { text-align: center; padding: 15px; border-radius: 12px; border: 2px solid #e0e0e0; }
                    .export-food-card.tried { background-color: #e8f5e8; border-color: #4caf50; }
                    .export-food-card.not-tried { background-color: #fff3e0; border-color: #ff9800; }
                    .export-food-image { width: 60px; height: 60px; object-fit: contain; margin: 0 auto 8px; border-radius: 6px; }
                    .export-food-image.error { background: #f0f0f0; display: flex; align-items: center; justify-content: center; font-size: 30px; color: #999; }
                    .export-food-name { font-size: 0.9rem; font-weight: 500; margin: 5px 0; }
                    .export-food-chinese { font-size: 0.8rem; color: #666; }
                </style>
            </head>
            <body>
                ${generateExportLayout()}
            </body>
            </html>
        `);
        iframeDoc.close();

        // Wait for iframe content to be ready
        const exportLayoutEl = iframeDoc.querySelector('.export-layout');
        await waitForImagesToLoad(exportLayoutEl);

        // Use html2canvas on the iframe content
        let canvas;
        try {
            canvas = await html2canvas(exportLayoutEl, {
                backgroundColor: '#ffffff',
                scale: 1.0, // 1:1 export
                useCORS: true,
                allowTaint: false,
                logging: false
            });
        } catch (err) {
            document.body.removeChild(iframe);
            alert('Export failed. Please try again.');
            return;
        }

        // Download PNG
        const link = document.createElement('a');
        link.download = `100-foods-before-1-${new Date().toISOString().slice(0, 10)}.png`;
        link.href = canvas.toDataURL('image/png');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up iframe
        if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
        }

		// Reset button
		exportBtn.textContent = originalText;
		exportBtn.disabled = false;

		// Close dropdown
		const moreMenu = document.querySelector('.more-menu');
		if (moreMenu) {
			moreMenu.classList.remove('show');
		}

		console.log('PNG export completed successfully');
	} catch (error) {
		console.error('PNG export failed:', error);
		alert('PNG export failed: ' + error.message);

        // Reset button on error
        const exportBtn = document.getElementById('export-png-btn');
        exportBtn.textContent = 'Export as PNG';
        exportBtn.disabled = false;

        // Cleanup on error: remove iframe if present
        const iframes = Array.from(document.querySelectorAll('iframe[src="about:blank"]'));
        for (const iframe of iframes) {
            if (iframe && iframe.parentNode) {
                iframe.parentNode.removeChild(iframe);
            }
        }
	}
}// Export as PDF using jsPDF library for automatic download
export async function exportAsPDF(generateExportLayout, waitForImagesToLoad) {
	try {
		// Show loading indicator
		const exportBtn = document.getElementById('export-pdf-btn');
		const originalText = exportBtn.textContent;
		exportBtn.textContent = 'Generating PDF...';
		exportBtn.disabled = true;

        // Create a hidden iframe for export isolation
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.left = '-9999px';
        iframe.style.top = '0';
        iframe.style.width = '1200px';
        iframe.style.height = '800px';
        iframe.style.border = 'none';
        iframe.style.background = 'white';
        document.body.appendChild(iframe);

        // Wait for iframe to load and then populate it
        await new Promise(resolve => {
            iframe.onload = resolve;
            iframe.src = 'about:blank';
        });

        // Get iframe document and write content
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <style>
                    body { margin: 0; padding: 0; background: white; }
                    .export-layout { background: white; padding: 40px; width: 1000px; box-sizing: border-box; margin: 0 auto; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; }
                    .export-header { text-align: center; margin-bottom: 30px; border-bottom: 3px solid #4ecdc4; padding-bottom: 20px; }
                    .export-title { font-size: 2.5rem; color: #333; margin: 0 0 10px 0; font-weight: 700; }
                    .export-progress { font-size: 1.2rem; color: #666; margin: 0; }
                    .export-date { font-size: 0.9rem; color: #999; margin-top: 10px; }
                    .export-category { margin-bottom: 40px; }
                    .export-category-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; }
                    .export-category-title { font-size: 1.8rem; font-weight: 600; margin: 0; }
                    .export-category-progress { font-size: 1rem; color: #666; }
                    .export-food-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 15px; }
                    .export-food-card { text-align: center; padding: 15px; border-radius: 12px; border: 2px solid #e0e0e0; }
                    .export-food-card.tried { background-color: #e8f5e8; border-color: #4caf50; }
                    .export-food-card.not-tried { background-color: #fff3e0; border-color: #ff9800; }
                    .export-food-image { width: 60px; height: 60px; object-fit: contain; margin: 0 auto 8px; border-radius: 6px; }
                    .export-food-image.error { background: #f0f0f0; display: flex; align-items: center; justify-content: center; font-size: 30px; color: #999; }
                    .export-food-name { font-size: 0.9rem; font-weight: 500; margin: 5px 0; }
                    .export-food-chinese { font-size: 0.8rem; color: #666; }
                </style>
            </head>
            <body>
                ${generateExportLayout()}
            </body>
            </html>
        `);
        iframeDoc.close();

        // Wait for iframe content to be ready
        const exportLayoutEl = iframeDoc.querySelector('.export-layout');
        await waitForImagesToLoad(exportLayoutEl);

        // Use html2canvas on the iframe content
        let canvas;
        try {
            canvas = await html2canvas(exportLayoutEl, {
                backgroundColor: '#ffffff',
                scale: 1.0, // 1:1 export
                useCORS: true,
                allowTaint: false,
                logging: false
            });
        } catch (err) {
            document.body.removeChild(iframe);
            alert('Export failed. Please try again.');
            return;
        }

        // Create PDF using jsPDF
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = pdfWidth - 20; // 10mm margin on each side
		// Calculate page height in px at canvas scale
		const pageHeightPx = Math.floor((canvas.width * (pdfHeight - 20)) / (pdfWidth - 20));

		// Find all .export-food-card top positions in the export layout (relative to .export-layout)
		const cardTops = Array.from(exportLayoutEl.querySelectorAll('.export-food-card'))
			.map(card => card.offsetTop)
			.filter((v, i, arr) => arr.indexOf(v) === i) // unique only
			.sort((a, b) => a - b);
		// Add the very end of the layout
		cardTops.push(exportLayoutEl.scrollHeight);

		// Map DOM y-positions to canvas y-positions (should be 1:1 if scale: 1.0)
		// Build page breaks: for each page, find the last card that fits
		let pageTops = [0];
		let lastY = 0;
		while (lastY < canvas.height) {
			let nextY = lastY + pageHeightPx;
			// Find the largest cardTop <= nextY
			let pageBreak = cardTops.find((top, idx) => top > lastY && top > nextY) || cardTops.find(top => top > lastY) || canvas.height;
			// But if nextY is past the last card, just end
			if (nextY >= canvas.height) {
				pageTops.push(canvas.height);
				break;
			}
			// Find the last cardTop <= nextY
			let lastCardOnPage = cardTops.filter(top => top > lastY && top <= nextY).pop();
			if (lastCardOnPage === undefined) lastCardOnPage = pageBreak;
			pageTops.push(lastCardOnPage);
			lastY = lastCardOnPage;
		}
		// Remove duplicates and sort
		pageTops = Array.from(new Set(pageTops)).sort((a, b) => a - b);

		for (let i = 0; i < pageTops.length - 1; i++) {
			const startY = pageTops[i];
			const endY = pageTops[i+1];
			const sliceHeight = endY - startY;
			const pageCanvas = document.createElement('canvas');
			pageCanvas.width = canvas.width;
			pageCanvas.height = sliceHeight;
			const pageCtx = pageCanvas.getContext('2d');
			pageCtx.drawImage(
				canvas,
				0, startY, // source x, y
				canvas.width, sliceHeight, // source w, h
				0, 0, // dest x, y
				canvas.width, sliceHeight // dest w, h
			);
			const imgData = pageCanvas.toDataURL('image/png');
			if (i > 0) pdf.addPage();
			pdf.addImage(
				imgData,
				'PNG',
				10, 10,
				imgWidth,
				(sliceHeight * imgWidth) / canvas.width
			);
		}
		pdf.save(`baby-food-progress-${new Date().toISOString().split('T')[0]}.pdf`);

        // Clean up iframe
        if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
        }

		// Reset button
		exportBtn.textContent = originalText;
		exportBtn.disabled = false;

		// Close dropdown
		const moreMenu = document.querySelector('.more-menu');
		if (moreMenu) {
			moreMenu.classList.remove('show');
		}

		console.log('PDF export completed successfully');
	} catch (error) {
		console.error('PDF export failed:', error);
		alert('PDF export failed: ' + error.message);

        // Reset button on error
        const exportBtn = document.getElementById('export-pdf-btn');
        exportBtn.textContent = 'Export as PDF';
        exportBtn.disabled = false;

        // Cleanup on error: remove iframe if present
        const iframes = Array.from(document.querySelectorAll('iframe[src="about:blank"]'));
        for (const iframe of iframes) {
            if (iframe && iframe.parentNode) {
                iframe.parentNode.removeChild(iframe);
            }
        }
	}
}
